import axios from 'axios';
import { Chatroom } from '../../models';
import { constants } from '../../constants';

export const getChatrooms = async () => {
  const token = localStorage.getItem('token');
  const res = await axios.get<{ chatrooms: Chatroom[] }>(
    `${constants.endpoint}/chatrooms`,
    {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  );
  return res.data.chatrooms;
};
